import { deliveryMemory } from "../../Objects/Memory/Memory"
import { API_ROUTES } from "../../configuration/RoutesApi"
import { useError } from "../../context/useErrorContext"
import { useLoad } from "../../context/useLoadContext"
import { GetRequest } from "../../services/ApiClientService"
import { useTranslation } from "react-i18next"
import { DeliveryEntity } from "../../Objects/DeliveryEntity/DeliveryEntity"
import { ERequestType } from "../../Enum/ERequestType"
import { dedupeDeliveries, filterActiveCourierDeliveries } from "./deliveryListUtils"

export const useGetDelivery = () => {
  const { t } = useTranslation("general")

  const { enableLoad, disableLoad } = useLoad()

  const { setError } = useError()

  const handleGetDelivery = async (onSuccess: any) => {
    enableLoad()

    try {
      const response = await GetRequest<DeliveryEntity[]>(API_ROUTES.DELIVERY.COURIER_PENDING, ERequestType.Courier)

      if (response.success) {
        const temp = response.data?.map((e) => new DeliveryEntity(e)) ?? []

        const now = new Date()

        deliveryMemory.setList(dedupeDeliveries(temp).filter((item) => filterActiveCourierDeliveries(item, now)))

        onSuccess()

        return
      }

      throw new Error(response.message)
    } catch (e: unknown) {
      const message = e instanceof Error ? e.message : t("label_unknown_error_description")
      setError(t("label_title_erro"), message)
    } finally {
      disableLoad()
    }
  }

  return {
    handleGetDelivery,
  }
}
